import { Supporter } from '@/types';
import { ListSummary } from '@/types/shared';
import AssignListPanelContent from '@components/AssignListPanelContent';
import OtherActionsPanelContent from '@components/OtherActionsPanelContent';
import Sidebar from '@components/Sidebar';
import { GridSortModel } from '@mui/x-data-grid';

export type PanelContent = 'assign' | 'otherActions';

type ListDetailRightPanelProps = {
  listId: string | undefined;
  listMetadata: ListSummary | undefined;
  rightPanelOpen: boolean;
  rightPanelContent: PanelContent;
  setRightPanelOpen: (open: boolean) => void;
  handleAssign: (destinationTab: string) => void;
  handleOtherActionsClose: () => Promise<void>;
  selectedContacts: Supporter[];
  sortModel: GridSortModel;
};

export default function ListDetailRightPanel({
  listId,
  listMetadata,
  rightPanelOpen,
  rightPanelContent,
  setRightPanelOpen,
  handleAssign,
  handleOtherActionsClose,
  selectedContacts,
  sortModel,
}: ListDetailRightPanelProps) {
  return (
    <Sidebar
      title={rightPanelContent === 'assign' ? 'Assignments' : 'Other actions'}
      isOpen={rightPanelOpen}
      position="right"
      floating
      noTopBorder={rightPanelContent === 'otherActions'}
    >
      {rightPanelContent === 'assign' && listMetadata ? (
        <AssignListPanelContent
          list={listMetadata}
          handleCancel={() => setRightPanelOpen(false)}
          handleAssign={handleAssign}
          key={rightPanelOpen ? 'assignOpen' : 'assignClosed'}
        />
      ) : rightPanelContent === 'otherActions' ? (
        <OtherActionsPanelContent
          onClose={handleOtherActionsClose}
          qFilter={{
            listIds: [listId ? parseInt(listId) : 0],
            contactIds:
              selectedContacts.length > 0
                ? selectedContacts.map((contact) => contact.id)
                : undefined,
          }}
          selectedContacts={selectedContacts}
          sortColumn={sortModel[0].field}
          sortOrder={sortModel[0].sort ?? 'asc'}
          listCount={listMetadata?.count || 0}
          listId={listMetadata?.id || 0}
        />
      ) : (
        <> </>
      )}
    </Sidebar>
  );
}
